import React from 'react';
import { FaChevronUp } from 'react-icons/fa';
import SearchBox from './SearchBox';

interface MobileSearchDrawerProps {
  searchOpen: boolean;
  setSearchOpen: (open: boolean) => void;
  hideResults?: boolean;
  isSearchScreen?: boolean;
}

const MobileSearchDrawer = ({ searchOpen, setSearchOpen }: MobileSearchDrawerProps) => {  return (
    <div
      className={`flex flex-row place-content-center w-full pb-2 mb-2 md:hidden h-20 transition-[margin,padding,width,height] duration-400 ${
        searchOpen ? 'mt-5 pt-2' : 'max-h-0'
      }`}
    >
      {searchOpen && (
        <div className="bg-dark-grey">
          <SearchBox isDrawer={true} />
          {/* Chevron below content */}
          <div className="flex justify-center align-bottom pt-4">
            <button
              onClick={() => setSearchOpen(false)}
              className="text-light-grey hover:text-white"
              aria-label="Close search"
            >
              <FaChevronUp size={16} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileSearchDrawer;
